import { object, string } from "yup";

const validationSchema = object().shape({
  search: string(),
});

export default () => validationSchema;
